import { AssetClassParameter } from "types/AssetClassParameter";
import { ActionType, getType } from "typesafe-actions";
import * as assetClassParametersActions from "./assetClassParametersActions";

export interface AssetClassParametersState {
  loading?: boolean;
  data?: AssetClassParameter[];
  error?: string;
}

export type AssetClassParametersActions = ActionType<typeof assetClassParametersActions>;

export default function assetClassParameters(
  state: AssetClassParametersState = {},
  action: AssetClassParametersActions
) {
  switch (action.type) {
    case getType(assetClassParametersActions.load):
      return { ...state, loading: true };
    case getType(assetClassParametersActions.loadSuccess):
      return {
        ...state,
        loading: false,
        data: action.data,
        error: undefined,
      };
    case getType(assetClassParametersActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
